import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sso',
  template: `
  `
})

export class SSOComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
